<template>
  
<svg xmlns="http://www.w3.org/2000/svg" width="142.682" height="38.814" viewBox="0 0 142.682 38.814">
  <g id="btn_send" transform="translate(-9.853 1.605)">
    <g id="Valider" transform="translate(9.853 -1.604)">
      <g id="Component_8_1" data-name="Component 8 – 1" transform="translate(0 -0.001)">
        <g id="Component_7_1" data-name="Component 7 – 1">
          <rect id="Rectangle_417" data-name="Rectangle 417" width="142.682" height="38.814" rx="19.407" fill="#ff5614"/>
        </g>
        <text id="J_12" data-name="J+12" transform="translate(50.342 25.907)" fill="#fdfdfe" font-size="16" font-family="SegoeUI-Bold, Segoe UI" font-weight="700"><tspan x="0" y="0">J+12</tspan></text>
      </g>
    </g>
  </g>
</svg>

</template>